import { useMemo } from 'react';

import {
  useEventsItemsFilteredQuery,
  VersionStates,
  type PageEventsBlock,
} from '@/components/common/Providers/GraphqlProvider/generated';

interface UseEventsItemsFilteredProps {
  eventsBlock?: PageEventsBlock;
  enabled?: boolean;
}

export const useEventsItemsFiltered = ({
  eventsBlock,
  enabled = true,
}: UseEventsItemsFilteredProps) => {
  // Extract query variables from eventsBlock configuration
  const queryVariables = useMemo(() => {
    if (!eventsBlock) return {};

    const variables: any = {};

    // Add contentSchemaId if contentSchema is configured
    if (eventsBlock.contentSchema?.id) {
      variables.contentSchemaId = eventsBlock.contentSchema.id;
    }

    // If hasDependencyFilter is true, we would need to get the current dependency
    // For now, we'll leave this undefined unless we have a specific dependency to filter by
    if (eventsBlock.hasDependencyFilter) {
      // This would need to be implemented based on your dependency context
      // variables.dependencyId = currentDependencyId;
    }
    //only enables
    variables.where = {
      eventStatus: [VersionStates.Active],
    };

    return variables;
  }, [eventsBlock]);

  // Use the generated Apollo hook
  const { data, loading, error } = useEventsItemsFilteredQuery({
    variables: queryVariables,
    skip: !enabled || !eventsBlock,
    fetchPolicy: 'cache-first',
  });

  // Transform and sort the events items
  const eventsItems = useMemo(() => {
    if (!data?.eventsItemsFiltered) return [];

    // Sort by createdAt in descending order (newest first)
    return [...data.eventsItemsFiltered].sort(
      (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  }, [data?.eventsItemsFiltered]);

  return {
    data: eventsItems,
    isLoading: loading,
    error,
    hasData: eventsItems.length > 0,
  };
};
